import * as React from "react";

const Icon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22.98}
      height={21.789}
      {...props}
    >
      <g data-name="Group 552">
        <path
          data-name="Path 160"
          d="M22.98 10.213L0 0l5.107 10.214H22.98zm0 1.362H5.107L0 21.789z"
          fill="#01aaea"
        />
      </g>
    </svg>
  );
}

export default Icon;
